import PritntPdfReceipt from '@/components/common/PritntPdfReceipt';
import ToastMe from '@/components/ui/ToastMe';
import {
    isThermalReceiptPrintingEnabled,
    printThermalOrderReceipt,
    resolveKitchenThermalPrinterName,
} from '@/lib/thermalReceipt';

const useOrderReceiptPrint = ({
    copyCount = 1,
    orderData,
    generalSetting,
    userData,
    receiptType = 'customer',
}) => {
    const { printRef, handleDownloadPdf } = PritntPdfReceipt(copyCount);

    const handlePrint = async () => {
        const shouldUseConfiguredThermalPrint = isThermalReceiptPrintingEnabled(generalSetting);
        const shouldAutoTryKitchenThermalPrint =
            receiptType === 'kitchen' && !shouldUseConfiguredThermalPrint;

        if (!shouldUseConfiguredThermalPrint && !shouldAutoTryKitchenThermalPrint) {
            handleDownloadPdf();
            return;
        }

        try {
            let printerName;
            if (shouldAutoTryKitchenThermalPrint) {
                printerName = await resolveKitchenThermalPrinterName(generalSetting);
                if (!printerName) {
                    handleDownloadPdf();
                    return;
                }
            }

            await printThermalOrderReceipt({
                orderData,
                generalSetting,
                userData,
                receiptType,
                copyCount,
                printerName,
            });
        } catch (error) {
            console.error('[ThermalReceipt] falling back to browser print', error);
            if (shouldUseConfiguredThermalPrint) {
                ToastMe(
                    error?.message ||
                        'Direct thermal printing failed. Opening the browser print dialog instead.',
                    'error'
                );
            }
            handleDownloadPdf();
        }
    };

    return {
        printRef,
        handlePrint,
        handleBrowserPrint: handleDownloadPdf,
    };
};

export default useOrderReceiptPrint;
